<klt-section
  title="Total Shareholder Returns (TSR) vs Total Accounting Returns (TAR)"
>
  <div class="graph-box">
    <klt-graph
      [loading]="loading"
      [height]="height"
      [options]="options"
      [titles]="titles"
      (filter)="runFilter($event)"
    >
    </klt-graph>
  </div>
</klt-section>
